import {
  Block,
  Button,
  Link,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import FailedActionModalBody from "#/shared/components/modals/FailedActionModalBody"
import { links } from "#/shared/constants"
import { useCopyValue } from "#/shared/hooks"

type FailedToCreateDepositErrorFooterProps = {
  depositReceipt: string
  onTryAgain: () => void
}

type FailedToCreateDepositErrorDescriptionProps = {
  description: string
}

type FailedToCreateDepositErrorProps = {
  title: string
} & FailedToCreateDepositErrorDescriptionProps &
  FailedToCreateDepositErrorFooterProps

function FailedToCreateDepositErrorFooter({
  depositReceipt,
  onTryAgain,
}: FailedToCreateDepositErrorFooterProps) {
  const [, theme] = useStyletron()
  const { label, copy } = useCopyValue(depositReceipt, "Copy deposit details")
  return (
    <Block display="flex" flexDirection="column" width="100%">
      <Button width="100%" onClick={copy} kind="primary" size="large">
        {label}
      </Button>
      <Button
        width="100%"
        onClick={onTryAgain}
        kind="secondary"
        size="large"
        overrides={{
          BaseButton: { style: { marginTop: theme.sizing.scale400 } },
        }}
      >
        Try again
      </Button>
    </Block>
  )
}

function FailedToCreateDepositErrorDescription({
  description,
}: FailedToCreateDepositErrorDescriptionProps) {
  const [, theme] = useStyletron()

  return (
    <ParagraphLarge
      color={theme.colors.contentSecondary}
      marginTop={theme.sizing.scale300}
      style={{ textAlign: "center" }}
    >
      {description} Copy the deposit details and{" "}
      <Link
        href={links.DISCORD_SUPPORT}
        target="_blank"
        rel="noopener noreferrer"
      >
        contact the support
      </Link>
      .
    </ParagraphLarge>
  )
}

export default function FailedToCreateDepositError({
  title,
  description,
  onTryAgain,
  depositReceipt,
}: FailedToCreateDepositErrorProps) {
  return (
    <FailedActionModalBody
      title={title}
      description={
        <FailedToCreateDepositErrorDescription description={description} />
      }
      footer={
        <FailedToCreateDepositErrorFooter
          depositReceipt={depositReceipt}
          onTryAgain={onTryAgain}
        />
      }
    />
  )
}
